<template>
  <div class="item-wrapper" v-loading="loading">
      <div class="item-header">
        <div class="goback" @click="goback"><img src="../../../../../static/images/fanhui.png" alt=""/>返回</div>
        <h2>{{planData.trainName}}</h2>
      </div>
      <div class="item-info">
        <h3>基本信息</h3>
        <div class="btn">
          <el-button type="primary" plain size="mini" @click="saveTrainPlan">保存</el-button>
        </div>
      </div>
    <div class="iten-form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="证件类型">
          <el-select v-model="formInline.certType" placeholder="请选择证件类型" size="mini">
            <el-option label="智能评估" value="智能评估"></el-option>
            <el-option label="智能财税" value="智能财税"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件级别">
          <el-select v-model="formInline.certLevel" placeholder="请选择证件级别" size="mini">
            <el-option label="初级" value="初级"></el-option>
            <el-option label="中级" value="中级"></el-option>
            <el-option label="高级" value="高级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开课年份">
          <el-input placeholder="" v-model="formInline.startCourseYear" :disabled="true" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="开课时间">
          <el-date-picker
            v-model="formInline.startCourseDate"
            type="daterange"
            unlink-panels
            size="mini"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
        </el-form-item>
      </el-form>
    </div>
    <div class="iten-courseInfo">
      <div class="courseInfo">
          <h3>开课信息</h3>
          <span>
            （<strong>*</strong>如果带班老师同时开课多个专业学生，则专业之间用“，”间隔）
           </span>
          <div class="test">
            <span>带班教师数：<i>{{countNum.teacherNumber}}</i></span>
            <span>培训学生总数：<i>{{countNum.studentNumber}}</i></span>
            <span>课时总数：<i>{{countNum.lessonNumber}}</i></span>
            <span>开课专业数：<i>{{countNum.professionNumber}}</i></span>
          </div>
      </div>
      <div class="btn">
        <el-button type="primary" plain size="mini" @click="addOpenInfo">添加</el-button>
      </div>
    </div>
      <div class="item-table" :style="'padding-bottom:16px'">
        <el-table :data="tableData" style="width: 100%" :height="windowHeight-365" :header-cell-style="headerCellStyle" class="collegeTable" :cell-style="cellStyle" :empty-text="empty" @selection-change="handleSelectionChange">
          <el-table-column prop="teacherName" label="带班教师姓名">
            <template slot-scope="scope">
              <el-input v-if="scope.row.show" v-model="scope.row.teacherName" placeholder="请输入内容" size="mini"></el-input>
              <span v-else>{{scope.row.teacherName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="studentsNamber" label="培训学生人数">
            <template slot-scope="scope">
              <el-input v-if="scope.row.show" v-model="scope.row.studentNumber" @keydown.native="number" @keyup.native="number" placeholder="请输入内容" size="mini"></el-input>
              <span v-else>{{scope.row.studentNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="classHour" label="课时数">
            <template slot-scope="scope">
              <el-input v-if="scope.row.show" v-model="scope.row.lessonNumber" @keydown.native="number" @keyup.native="number" placeholder="请输入内容"  size="mini"></el-input>
              <span v-else>{{scope.row.lessonNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="openingMajor" label="开课专业">
            <template slot-scope="scope">
              <el-input v-if="scope.row.show" v-model="scope.row.lessonProfession" placeholder="请输入内容" size="mini"></el-input>
              <span v-else>{{scope.row.lessonProfession}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="teacherLevel" label="教师职称" width="140px">
            <template slot-scope="scope">
              <el-input v-if="scope.row.show" v-model="scope.row.teacherLevel" placeholder="请输入内容" size="mini"></el-input>
              <span v-else>{{scope.row.teacherLevel}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="certifiedTeacher" label="是否1+X培训认证教师" width="145px">
            <template slot-scope="scope">
              <el-select v-if="scope.row.show" v-model="scope.row.isPermit" placeholder="请选择教师类别" size="mini">
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
              <span v-else>{{scope.row.isPermit}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phoneNumber" label="手机号">
            <template slot-scope="scope">
              <el-input v-if="scope.row.show" v-model="scope.row.phoneNumber" @keydown.native="number" @keyup.native="number" placeholder="请输入内容" size="mini"></el-input>
              <span v-else>{{scope.row.phoneNumber | desensitizationText}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150px">
            <template slot-scope="scope">
              <div v-if="scope.row.show">
                <el-button  round size="small" @click="cancelAddTrainPlanRecordTeacher(scope.row,scope.$index)">取消</el-button>
                <el-button  round size="small" @click="saveTrainPlanRecordTeacher(scope.row)">保存</el-button>
              </div>
              <div v-else>
                <el-button  round size="small" @click="editTrainPlanRecordTeacher(scope.row)">修改</el-button>
                <el-button  round size="small" @click="delTrainPlanRecordTeacher(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
</template>
<script>
  import * as api from "../../../../api/educationalApi"
  import {desensitization} from "@/utils/utils";
  export default{
    filters:{
      desensitizationText(val){
        return desensitization(val)
      }
    },
      name:'openingInfomation',
      data(){
          return{
              loading: false,
              tableData: [],
              teacherName:'',
              studentsNamber:'',
              classHour:'',
              openingMajor:'',
              certifiedTeacher:'',
              phoneNumber:'',
              formInline: {
                  certType: '',
                  certLevel: '',
                  startCourseYear:'',
                  startCourseDate: '',
              },
              trainPlanRecordId:'',
              empty: '暂无数据',
              windowHeight: window.innerHeight,
              height: window.innerHeight - 115 + "px", // 表格高度根据窗口高度来决定
              pageTotal: {
                  currentPage: 1,
                  pageSize: 10,
                  total: 0,
              },
              countNum:{
                  lessonNumber: 0,
                  professionNumber: 0,
                  studentNumber: 0,
                  teacherNumber: 0
              },
              pickerOptions: {
                  disabledDate : time => {
                      return this.disabledDate(time)
                  }
              },
              planEndTime:'',
              planStartTime:'',
          }
      },
      props:{
          planData: Object
      },

      mounted(){
        //赋值开课年份
        this.formInline.startCourseYear = this.planData.planYear;
        this.planEndTime = this.planData.planEndTime,this.planStartTime = this.planData.planStartTime;
        this.getList();
      },
      methods:{
          disabledDate(time){
            return time.getTime() > new Date(this.planEndTime).getTime() ||  time.getTime() < new Date(this.planStartTime).getTime()
          },
          number(e) {
            e.target.value = e.target.value.replace(/[^\d]/g, "");
          },
          goback() {//返回上一级
            this.$emit('switchShow',true )
          },
          // 表格头部样式
          headerCellStyle({
                              row,
                              column,
                              rowIndex,
                              columnIndex
                          }) {
              if(rowIndex === 0 && columnIndex == 2) {
                  return "background:rgba(83,151,247,0.1);color:#999999; text-align:left !important; padding-left:20px !important;";
              } else if(rowIndex === 0 && columnIndex == 3) {
                  return "background:rgba(83,151,247,0.1);color:#999999; text-align:left !important; padding-left:20px !important;";
              } else {
                  return "background:rgba(83,151,247,0.1);color:#999999;";
              }
          },
          cellStyle(row, column, rowIndex, columnIndex) {
              if(row.columnIndex === 2 || row.columnIndex === 3) {
                  return "text-align:left !important;padding-left:20px !important;";
              }
          },
          currentPageFn(val) {
              this.loading = true;
              this.pageTotal.currentPage = val;
              this.getStudentList();
          },
          handleSelectionChange(val) {
              this.multipleSelection = val;
          },
          getList(){
              let deptId = sessionStorage.getItem("deptId");
              let trainPlanId = this.planData.trainPlanId;
              api.getTrainPlanRecord(trainPlanId,deptId).then(res => {
                  if(res.code == 0) {
                    let data = res.data;
                    if(!!data.trainPlanRecord && data.trainPlanRecord.length > 0){
                        this.trainPlanRecordId = data.trainPlanRecord[0].id;
                        this.formInline.certType = data.trainPlanRecord[0].certificateType;
                        this.formInline.certLevel = data.trainPlanRecord[0].cartificateLevel;
                        this.formInline.startCourseDate=[data.trainPlanRecord[0].lessonStartTime,data.trainPlanRecord[0].lessonEndTime];

                        this.getTrainPlanRecordCount();
                    }
                    //显示开课信息列表
                      this.tableData = data.trainPlanRecordTeacher;
                    //   if(!!data.trainPlanRecordTeacher && data.trainPlanRecordTeacher.length > 0){
                    //       this.tableData = data.trainPlanRecordTeacher;
                    //   }else{
                    //
                    //   }
                  } else {
                      this.$messageError(res.msg);
                      return
                  }
                  this.loading = false;
              }).catch(error => {
                  console.log(error)
              })
          },
          //开课信息修改保存
          saveTrainPlan(){
              let depId = sessionStorage.getItem("deptId");
              let deptName = sessionStorage.getItem("deptName");
              let lessonStartTime,lessonEndTime = "";
              if(!this.formInline.certType){
                  this.$messageWarning("证件类型不能为空")
                  return;
              }
              if(!this.formInline.certLevel){
                  this.$messageWarning(" 证件级别不能为空")
                  return;
              }
              if(!this.formInline.startCourseYear){
                  this.$messageWarning(" 开课年份不能为空")
                  return;
              }
              if(!this.formInline.startCourseDate || this.formInline.startCourseDate.length==0){
                  this.$messageWarning("开课时间不能为空")
                  return;
              }
              if(!!this.formInline.startCourseDate && this.formInline.startCourseDate.length>0){
                  lessonStartTime = this.formInline.startCourseDate[0];
                  lessonEndTime = this.formInline.startCourseDate[1]
              }
              let param = {
                  certificateType:this.formInline.certType,
                  cartificateLevel:this.formInline.certLevel,
                  lessonYear:this.formInline.startCourseYear,
                  lessonStartTime:lessonStartTime,
                  lessonEndTime:lessonEndTime,
                  deptId: depId,
                  deptName: deptName,
                  deptNo: sessionStorage.getItem('deptNo'),
                  trainPlanId:this.planData.trainPlanId
              };
              if(!!this.trainPlanRecordId){
                  param.id = this.trainPlanRecordId;
              }
              api.saveTrainPlan(param).then(res => {
                  if(res.code == 0) {
                      this.trainPlanRecordId=res.data;
                      this.$messageSuccess('保存成功')
                  } else {
                      this.$messageError(res.msg);
                      return
                  }
                  this.loading = false;
              }).catch(error => {
                  console.log(error)
              })
          },

          //添加开课信息
          addOpenInfo(){
              let obj = {show:true}
              this.tableData.push(obj);
          },
          //修改开课信息
          editTrainPlanRecordTeacher(row,index){
              console.log(row)
              // row.show=true;
             this.$set(row,'show',true);
          },

          //教务端保存教学计划老师信息
          saveTrainPlanRecordTeacher(row){
              let {show,...param} = row;
              param.trainPlanRecordId = this.trainPlanRecordId;
              let reg = /^[1-9]\d*$/;
              if(!reg.test(row.phoneNumber)){
                  this.$messageWarning("请输入正确的手机号")
                  return false;
              }
              if(!reg.test(row.lessonNumber)){
                  this.$messageWarning("请输入课时数整数")
                  return false;
              }
              if(!reg.test(row.studentNumber)){
                  this.$messageWarning("请输入学生人数整数")
                  return false;
              }
              //编辑
              if(!!param.id){
                api.updateTrainPlanRecordTeacher(param).then(res => {
                      if(res.code == 0) {
                          // row.show=false
                          this.$messageSuccess('保存成功')
                          this.getList();
                      } else {
                          this.$messageError(res.msg);
                          return
                      }
                      this.loading = false;
                  }).catch(error => {
                      console.log(error)
                  })
              }else{
                api.saveTrainPlanRecordTeacher(param).then(res => {
                      if(res.code == 0) {
                          // row.show=false
                          this.$messageSuccess('保存成功')
                          this.getList();
                      } else {
                          this.$messageError(res.msg);
                          return
                      }
                      this.loading = false;
                  }).catch(error => {
                      console.log(error)
                  })
              }
          },
          //开课信息取消
          cancelAddTrainPlanRecordTeacher(row,num){
              if(!!row.id){
                  this.getList();
              }else{
                  this.tableData.splice(num,1);
              }
              this.$message({
                  message: '已取消修改',
                  type: 'warning'
              });

          },
          //开课信息删除
          delTrainPlanRecordTeacher(row){
              this.$confirm('此操作开课信息列表, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                  let recordTeacherId = row.id;
                  api.deleteTrainPlan(recordTeacherId).then(res => {
                      if(res.code == 0) {
                        this.$messageSuccess('删除成功')
                          this.getList();
                      } else {
                          this.$messageError(res.msg);
                          return
                      }
                      this.loading = false;
                  }).catch(error => {
                      console.log(error)
                  })
              });

          },

          getTrainPlanRecordCount(){
              // let recordId = 21;
              let recordId = this.trainPlanRecordId;
              api.getTrainPlanRecordCount(recordId).then(res => {
                  if(res.code == 0) {
                      this.countNum = res.data;
                  } else {
                      this.$messageError(res.msg);
                      return
                  }
                  this.loading = false;
              }).catch(error => {
                  console.log(error)
              })
          }

      }
  }
</script>
<style scoped lang="scss">
  .item-wrapper {
    padding: 0 16px;

    .item-header {
      height: 48px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #5397f7;

      .goback {
        font-size: 12px;
        color: #999;
        padding-right: 5px;
        line-height: 14px;
        cursor: pointer;
        img{
          display: inline-block;
          width: 14px;
          height: 14px;
          vertical-align: middle;
          padding-right: 4px;
        }
      }

      h2 {
        border-left: 2px solid #5397f7;
        color: #5397f7;
        font-size: 14px;
        padding-left: 4px;
        line-height: 10px;
      }
    }

    .item-info {
      height: 48px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(213, 213, 213, 1);
      justify-content: space-between;

      h3 {
        border-left: 2px solid #5397f7;
        color: #5397f7;
        font-size: 14px;
        padding-left: 4px;
        line-height: 10px;
      }
    }

    .iten-form {
      width: 98%;
      height: 45px;
      border: 1px solid rgba(226, 226, 226, 1);
      border-radius: 4px;
      margin: 15px 0px;
      padding: 10px;
    }

    .iten-courseInfo {
      height: 48px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(213, 213, 213, 1);
      justify-content: space-between;
      .courseInfo {
        display: flex;
        h3 {
          color: #5397f7;
          font-size: 14px;
          padding-left: 6px;
          position: relative;
          &::after{
            content: '';
            width: 2px;
            height: 12px;
            background: #5397f7;
            position: absolute;
            left: 0;
            top: 1px;
          }
        }

        span {
          color: #999;
          font-size: 12px;
          margin-left: 10px;

          strong {
            color: #ff0000;
          }
        }
      }

      .test {
        span {
          color: #333;
          font-size: 14px;

          i {
            font-size: 14px;
            color: #5397F7;
          }
        }
      }
    }

    .item-table {
      margin-top: 16px;

      .collegeTable {
        border: 1px solid #ebebeb;
        border-radius: 4px;
        border-bottom: 0;
      }

      /deep/ .el-table__empty-text {
        display: block;
        width: 200px;
        height: 200px;
        padding-top: 190px;
        color: #909399;
        box-sizing: border-box;
        background: url('../../../../../static/images/wujieguo.png') no-repeat;
      }
    }

    /deep/ .el-dialog__header {
      background: #edf4ff;
      border-radius: 8px 8px 0 0;
      height: 18px;

      &:before {
        width: 2px;
        height: 10px;
        background: rgba(83, 151, 247, 1);
        opacity: 1;
        border-radius: 4px;
      }
    }

    /deep/ .el-dialog__title {
      display: block;
      font-size: 14px;
      color: #5397f7;
      border-left: 2px solid #5397f7;
      padding-left: 5px;
      line-height: 10px;
    }

    /deep/ .el-dialog__footer {
      .el-button {
        width: 79px;
        height: 32px;
        line-height: 32px;
        padding: 0;
      }
    }

    .failMsg {
      color: #F00000;
      text-align: center;

      a {
        cursor: pointer;
        color: #5397F7;
      }
    }

    .upload-content {
      padding: 90px;
      display: flex;
      justify-content: space-between;

      .el-input {
        width: 240px;
        margin-bottom: 16px;
      }

      .left {
        position: relative;

        p {
          font-size: 12px;
          color: #999999;
          margin-bottom: 6px;

          i {
            color: #E34646;
          }

          a {
            cursor: pointer;
            color: #5397F7;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        span {
          position: absolute;
          width: 64px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          border-radius: 0px 4px 4px 0px;
          right: 0;
          top: 0;
          color: #FFFFFF;
        }

        .off {
          background: rgba(226, 226, 226, 1);
        }

        .on {
          cursor: pointer;
          background: #5397F7
        }
      }

      .right {
        width: 88px;
        height: 88px;
        text-align: center;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(226, 226, 226, 1);
        border-radius: 4px;

        img {
          display: inline-block;
          width: 32px;
          height: 32px;
          margin-top: 16px;
          margin-bottom: 4px;
        }

        p {
          color: #999999;
        }

        .upload-demo {
          width: 100%;
          height: 100%;
        }
      }
    }

    .tishi {
      position: absolute;
      top: 2px;
      right: -24px;
    }

    /deep/ .el-button--small,
    .el-button--small.is-round {
      padding: 5px 15px;
      color: #5397F7;
    }

    .classDialog {
      /deep/ .el-dialog__body {
        padding: 30px 56px;
      }
    }
    /deep/ .el-select{
      width: 120px;
    }
    /deep/ .el-form--inline .el-form-item__content {
          width: 120px;
        }

     /deep/ .el-range-editor--mini.el-input__inner {
      width: 260px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educationalAdminMenu/openingInformation.vue